export function buildIconAriaProps(ariaLabel) {
  return ariaLabel ? {
    'aria-label': ariaLabel,
    role: 'img'
  } : {
    'aria-hidden': 'true'
  };
}